import * as React from 'react';

export class RemoveButton extends React.Component<{ onClick: () => any }, any> {
    render() {
        return <span className="glyphicon glyphicon-remove" onClick={this.props.onClick} title={'Remove'}></span>;
    }
}
